import { useState } from 'react';
// @mui
import { alpha } from '@mui/material/styles';
import { Box, Divider, Typography, MenuItem } from '@mui/material';
// routes
// import { PATH_DASHBOARD, PATH_AUTH } from '../../../routes/paths';
// auth
// import { useAuthContext } from '../../../auth/useAuthContext';
// components
import { CustomAvatar } from 'lib/custom-avatar';
import MenuPopover from 'lib/menu-popover';
import { IconButtonAnimate } from 'lib/animate';
import useUser from 'features/auth/useUser';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import { Link } from 'infrastructure/router';
import { WebRoutes } from 'consts/enpoints/web';
import routes from 'consts/routes';
import { Authorized } from 'ui/layouts/Auth';
import useLogout from 'features/auth/useLogout';
import { Avatar } from '@mui/material';
import PermIdentityIcon from '@mui/icons-material/PermIdentity';

// ----------------------------------------------------------------------

// const OPTIONS = [
//   {
//     label: 'Home',
//     linkTo: '/',
//   },
//   {
//     label: 'Profile',
//     linkTo: WebRoutes.Home,
//   },
//   {
//     label: 'Settings',
//     linkTo: WebRoutes.Home,
//   },
// ];

// ----------------------------------------------------------------------

export default function AccountPopover() {
  // const navigate = useNavigate();
  const logout = useLogout();
  // const { user, logout } = useAuthContext();
  const { getUserName, user } = useUser();
  const userHasName = user.firstName || user.lastName;

  const [openPopover, setOpenPopover] = useState<HTMLElement | null>(null);

  const handleOpenPopover = (event: React.MouseEvent<HTMLElement>) => {
    setOpenPopover(event.currentTarget);
  };

  const handleClosePopover = () => {
    setOpenPopover(null);
  };

  const onLogout = () => (
    logout()
      .then(handleClosePopover)
  );

  // const handleClickItem = (path: string) => {
  //   handleClosePopover();
  //   navigate(path);
  // };

  return (
    <>
      <IconButtonAnimate
        onClick={handleOpenPopover}
        sx={{
          p: 0,
          ...(openPopover && {
            '&:before': {
              zIndex: 1,
              content: "''",
              width: '100%',
              height: '100%',
              borderRadius: '50%',
              position: 'absolute',
              bgcolor: (theme) => alpha(theme.palette.grey[900], 0.8),
            },
          }),
        }}
      > {
          userHasName ?
            <CustomAvatar
              alt={getUserName()}
              name={getUserName()}
            />
            :
            <Avatar>
              <PermIdentityIcon />
            </Avatar>
        }
      </IconButtonAnimate>

      <MenuPopover open={openPopover} onClose={handleClosePopover} sx={{ width: 200, p: 0 }}>
        <Box sx={{ my: 1.5, px: 2.5 }}>

          <Typography variant="subtitle2" noWrap>
            {getUserName()}
          </Typography>

          <Authorized
            {...routes[WebRoutes.Profile]}
            fallback={null}
          >
            <ListItemButton
              component={Link}
              to={WebRoutes.Profile}
            >
              <ListItemText primary='Profile' />
            </ListItemButton>
          </Authorized>

          <Typography variant="body2" sx={{ color: 'text.secondary' }} noWrap>
            {user.email}
          </Typography>
        </Box>

        <Divider sx={{ borderStyle: 'dashed' }} />

        {/* <Stack sx={{ p: 1 }}>
          {OPTIONS.map((option) => (
            <MenuItem key={option.label} onClick={() => handleClickItem(option.linkTo)}>
              {option.label}
            </MenuItem>
          ))}
        </Stack> */}

        <Divider sx={{ borderStyle: 'dashed' }} />

        <MenuItem
          sx={{
            m: 1
          }}
          onClick={onLogout}
        >
          Logout
        </MenuItem>
      </MenuPopover>
    </>
  );
}
